import styled, { css } from 'styled-components'
import { ifNotProp, ifProp, prop, switchProp } from 'styled-tools'
import searchIcon from '@images/searchicon.svg'
import colorsOptions from '../stories/fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../stories/fundamentals/text-styles/constants'

export const BreadcrumbBarWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${ifNotProp('noPadding', prop('padding', '16px'))};
  ${ifProp(
    'noBg',
    css`
      background-color: transparent;
      border-bottom: none;
    `,
    css`
      background-color: ${colorsOptions.greys.white};
      border-bottom: 1px solid ${colorsOptions.greys['grey-20']};
    `
  )}
`

export const BreadcrumbWrapper = styled.ul`
  display: flex;
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  align-items: center;
`

export const QuickFilterWrapper = styled.ul`
  display: flex;
  ${ifNotProp(
    'last',
    css`
      padding-right: 8px;
      border-right: 1px solid black;
    `
  )}
  & > li {
    flex: 1 1 auto;
    min-width: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
`

export const SubSectionWrapper = styled.div`
  ${switchProp('align', {
    left: css`
      margin-right: auto;
    `,
    center: css`
      margin-left: auto;
      margin-right: auto;
    `,
    right: css`
      margin-left: auto;
    `
  })}
`

export const QuickFilterItem = styled.li`
  display: flex;
  align-items: center;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-600']]}
  &:not(:last-child) {
    &:after {
      content: '';
      width: 3px;
      height: 3px;
      margin-left: 8px;
      margin-right: 8px;
      border-radius: 50%;
      background: ${colorsOptions.greys['grey-50']};
      display: inline-block;
    }
  }
`

export const QuickFilterLabel = styled.li`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-400']]}
  margin-right: 8px;
`

export const SearchField = styled.input`
  cursor: pointer;
  color: ${colorsOptions.greys['grey-100']};
  padding-left: 20px;
  padding-right: 8px;
  background: url('${searchIcon}') no-repeat 3px 3px;
  background-size: 14px;
  line-height: 20px;
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-400']]}
  width: ${({ value }) => (value ? 72 : 20)}px;
  transition: width 0.5s;
  &:focus {
    width: 72px;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }
  @media (max-width: 767px) {
    line-height: 24px;
  }
`

export const QuickFilterButton = styled.button`
  ${ifProp(
    'active',
    css`
      color: ${colorsOptions.docuToolsOrange.orange};
    `
  )}
`
